// extracted by mini-css-extract-plugin
export default {"root":"TooltipButton_root__YcglA"};